import React from 'react'
import { Chip } from './chips'

interface LockedChipProps {
  isLocked?: boolean
}

export default function LockedChip({ isLocked }: LockedChipProps) {
  return <Chip variant={isLocked ? 'red' : 'green'}>{isLocked ? 'Locked' : 'Unlocked'}</Chip>
}
